import queryString from 'query-string'

export const INQUIRY_START = (orgId) => {
    return "/organization/" + orgId + "/student/storage/inquiry/start"
}
export const INQUIRY_GET_MEDIA = (orgId, id) => {
    return "/organization/" + orgId + "/student/storage/inquiry/" + id + "/media"
}
export const INQUIRY_SAVE = (orgId, id, isReview) => {
    return "/organization/" + orgId + "/student/storage/inquiry/" + id + (isReview ? "?action=review" : "?action=save")
}
export const INQUIRY_GET = (orgId, id) => {
    return "/organization/" + orgId + "/student/storage/inquiry/" + id
}
export const INQUIRY_SUBMIT = (orgId, id, action) => {
    return "/organization/" + orgId + "/student/storage/inquiry/" + id + "?action=" + action
}
export const INQUIRY_CREATE_MEDIA = (orgId, id, urlQueryObject) => {
    return "/organization/" + orgId + "/student/storage/inquiry/" + id + "/media?" + queryString.stringify(urlQueryObject, {encode: true});
}
export const INQUIRY_DELETE_MEDIA = (orgId, id, mediaId) => {
    return "/organization/" + orgId + "/student/storage/inquiry/" + id + "/media/" + mediaId
}
export const DEVICE_REGISTER = (data) => {
    return "/device/register?" + queryString.stringify(data, {encode: true})
}
export const DEVICE_ADAPT = (id) => {
    return "/adapt/custom/discharge/" + id
}
export const DEVICE_ADAPT_RESOURCE = () => {
    return "https://yaleembedapi.amstonstudio.com/adapt/resources"
}
export const DEVICE_ADAPT_START = () => {
    return "/adapt/custom/discharge/start"
}
export const DEVICE_ADAPT_UPDATE = (id) => {
    return "/adapt/custom/discharge/" + id
}
export const DEVICE_ADAPT_STEP = (id) => {
    return "/device/" + id + "/survey/step"
}
export const DEVICE_ADAPT_PREVIOUS_STEP = (id, surveyId) => {
    return "/device/" + id + "/survey/" + surveyId + "/step/back"
}
